/**
 * Runs `fn` once the DOM is ready — immediately if DOMContentLoaded has already fired (e.g. the script was
 * loaded after first paint), otherwise on DOMContentLoaded, exactly as a plain listener would.
 */
export function onReady(fn: () => void | Promise<void>): void {
  const nav = performance.getEntriesByType('navigation')[0] as
    | PerformanceNavigationTiming
    | undefined;
  if (nav && nav.domContentLoadedEventEnd > 0) {
    void fn();
  } else {
    document.addEventListener('DOMContentLoaded', () => void fn(), {
      once: true,
    });
  }
}
